
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abroad",
      function () {
        return require("private-next-pages/abroad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abroad"])
      });
    }
  